import React, { useEffect, useRef } from "react";
import Vivus from "vivus";
import styles from "../Card/Card.module.scss";

export default ({
  delay = 1200,
  offsets = { top: "-20px", bottom: "-20px", left: "-10px", right: "-10px" },
  style = {},
}) => {
  const ref = useRef(null);
  useEffect(() => {
    let vivus;
    let timeout = setTimeout(() => {
      vivus = new Vivus(ref.current, {
        type: "scenario",
        duration: 50,
        delay: 0,
        //https://github.com/maxwellito/vivus/issues/51
        onReady: function (obj) {
          obj.el.style.opacity = 1;
        },
      });
    }, delay);
    return () => {
      clearTimeout(timeout);
      vivus && vivus.destroy();
    };
  }, [delay]);

  //svg created with RoughJS
  // const svg = document.getElementById('svg');
  // const rc = rough.svg(svg);
  // svg.appendChild(rc.ellipse(300, 200, 600, 400));
  return (
    <div className={styles.circleContainer} style={offsets}>
      <svg
        ref={ref}
        className="w-100 h-100"
        preserveAspectRatio="none"
        xmlns="http://www.w3.org/2000/svg"
        x="0px"
        y="0px"
        style={{ opacity: 0, overflow: "visible", maxHeight: "100%", ...style }}
        viewBox="0 0 600 400"
      >
        <path
          fill="none"
          stroke="#1cb922"
          strokeWidth="20"
          d="M442.9169523005798 26.566853641920716 C498.13639370780135 43.8171096330035, 553.9100077790745 89.05732169761828, 577.2783943623851 128.36292767911698 C600.6467809456958 167.66853366061568, 603.388006687316 222.26421120830847, 583.1272718004439 262.400489530913 C562.8665369135717 302.53676785351746, 510.344495507737 347.0235389798249, 455.71398504115217 369.180597614744 C401.08347457456733 391.3376562496631, 318.67753221260296 401.8879939896422, 255.34420900093494 395.3428413404276 C192.01088578926692 388.79768869121295, 118.09434516180494 361.7895865954024, 75.7140457711441 329.90968171945616 C33.333746380483255 298.0297768435099, 2.591097913234843 246.34881432109643, 1.0624126569698547 204.0634120847502 C-0.4662725992951333 161.778009848404, 26.522940456902482 109.13892696155466, 66.54193423355417 76.1972683013788 C106.56092801020586 43.255609641202945, 168.47260831861286 9.905985093223983, 241.17637531687998 6.413460123695103 C313.8801423151471 2.920935154166223, 452.337754226692 40.882963719699774, 502.76453622315694 55.24211848420552 C553.1913182196218 69.60127324871127, 547.3087801072575 90.36493244573701, 543.7370672956694 92.56838871072958 M300.04885383603937 3.9478458620039873 C360.8054297850238 1.5225488712968391, 442.7039721933755 22.61109696406824, 491.6200406114361 49.67503530390451 C540.5361090294966 76.73897364374078, 582.4145997298017 124.7306935354201, 593.545264344403 166.3314759010216 C604.6759289590043 207.9322582666231, 590.201683797862 262.6995018785005, 558.4040282990442 299.2797294975135 C526.6063728002264 335.85995711652646, 462.7769219620901 371.3327028847039, 402.75933135149626 385.8128416150996 C342.7417407409024 400.2929803454953, 258.41729918251025 400.4202226382393, 198.2984846354811 386.16056187988784 C138.17967008845193 371.9009011215364, 74.16348032589599 336.91956979256656, 42.04644406932124 300.25487706499086 C9.92940781274649 263.59018433741517, -5.444705567718074 208.09564819215012, 5.596267096032591 166.17240551443348 C16.637239759783256 124.24916283671683, 59.389553778947594 76.03880143321224, 108.29228005182523 48.71542099869097 C157.19500632470286 21.392040564169704, 267.09867104192665 9.446960088511815, 299.0126247332984 2.2321229073058646 C330.9265784246702 -4.982714273900086, 299.3621856518839 2.106638583094129, 299.7760022000557 5.426397911455268"
        ></path>
      </svg>
    </div>
  );
};
